module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-wedding-ceremony-e374057186307d8aa55059fae19cb833.jpg";